const de = {
  startSuccess: 'Start des Wahldurchlaufs erfolgreich',
  startFailed:
    'Start der Wahl fehlgeschlagen. Vermutlich wurde Sie bereits gestartet. Versuchen Sie die Seite neu zu laden',
  precalculate: 'Vorläufige Belegung berechnen',
  lastUpdate: 'Zuletzt aktualisiert am {{date}}',
  nextScheduledUpdate: 'Nächste geplante Aktualisierung am {{date}}',
  state: 'Status: {{state}}',
  studentSignedOut: 'Der Student hat sich aus dem Modul ausgetragen'
};

export default de;
export type ModuleSelectionLotteryTranslation = typeof de;
